const cachedPermissionState = {
    motion: null,
    orientation: null
};

export const requestPermissions = () => {
    if (typeof DeviceMotionEvent.requestPermission === 'function') {
        DeviceMotionEvent.requestPermission()
            .then(permissionState => {
                if (permissionState === 'granted') {
                    permissionState.motion = 'granted'
                }
            })
            .catch(console.error);
    } else {
        // handle regular non iOS 13+ devices
    }

    if (typeof DeviceOrientationEvent.requestPermission === 'function') {
        DeviceOrientationEvent.requestPermission()
            .then(permissionState => {
                if (permissionState === 'granted') {
                    cachedPermissionState.orientation = 'granted';
                }
            })
            .catch(console.error);
    } else {
        // handle regular non iOS 13+ devices
    }
};
